import resellersModule from "../resellersModule.js";

function resellersPaneController(resaleService, $q, cursorPaginationServiceV2, cursorPaginationConstants) {
    "ngInject";
    var ctrl = this;

    const resellersLoaded = function (resaleRecords) {
        ctrl.resellersLoading = false;
        resaleRecords.forEach(function (resaleRecord) {
            var existingRecord = ctrl.resaleDeduplicator[resaleRecord.userAssetId];
            if (existingRecord) {
                // Already exists in resaleRecords, update the information we know about it
                existingRecord.price = resaleRecord.price;
                existingRecord.seller = resaleRecord.seller;

                return;
            }

            ctrl.resaleDeduplicator[resaleRecord.userAssetId] = resaleRecord;
            ctrl.resaleRecords.push(resaleRecord);
        });
    };

    const resellersLoadFailure = function (e) {
        if (e.type === cursorPaginationConstants.errorType.pagingParametersChanged) {
            // Another request started, do nothing.
            return;
        }

        ctrl.resellersLoading = false;
    };

    const resellersPager = cursorPaginationServiceV2.createPager({
        pageSize: 10,
        loadPageSize: 100,

        getItems(pagingParameters) {
            return $q(function (resolve, reject) {
                resaleService.getResellers(ctrl.assetData.id, pagingParameters).then(resellers => {
                    resolve({
                        nextPageCursor: resellers.nextPageCursor,
                        items: resellers.data
                    });
                }).catch(reject);
            });
        }
    });

    ctrl.loadMore = function () {
        ctrl.resellersLoading = true;
        resellersPager.loadNextPage().then(resellersLoaded).catch(resellersLoadFailure);
    };

    const init = function () {
        ctrl.resaleRecords = [];
        ctrl.resaleDeduplicator = {};
        ctrl.canLoadMore = resellersPager.canLoadNextPage;

        resellersPager.loadFirstPage().then(resellersLoaded).catch(resellersLoadFailure);
    };

    ctrl.$onInit = init;
}

resellersModule.controller("resellersPaneController", resellersPaneController);
export default resellersPaneController;